import { render } from "./IntroStart.vue?vue&type=template&id=499ebf96&scoped=true"
import script from "./IntroStart.vue?vue&type=script&lang=js"
export * from "./IntroStart.vue?vue&type=script&lang=js"

import "./IntroStart.vue?vue&type=style&index=0&id=499ebf96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499ebf96"]])

export default __exports__